<div class="app-topnav-content">
  <mat-toolbar color="primary" class="lns-toolbar">
    <span class="home-link" [routerLink]="['/']">
      <img src="./assets/images/logo-leonus.png" />
    </span>

    <div class="lns-navbar">
      <mat-nav-list>
        @if (showNavLink(userCanRead)) {
          <a
            class="lns-nav-link"
            [routerLink]="['/users']"
            routerLinkActive="active"
            >
            <span class="nav-link-title">{{ "users.users" | translate }}</span>
          </a>
        }
        @if (showNavLink(clientCanRead)) {
          <a
            class="lns-nav-link"
            [routerLink]="['/clients']"
            routerLinkActive="active"
            >
            <span class="nav-link-title">{{
              "clients.clients" | translate
            }}</span>
          </a>
        }
        @if (showNavLink(deviceCanRead)) {
          <a
            class="lns-nav-link"
            [routerLink]="['/staffs']"
            routerLinkActive="active"
            >
            <span class="nav-link-title">{{ "staffs.staffs" | translate }}</span>
          </a>
        }
        @if (showNavLink(roleCanRead)) {
          <a
            class="lns-nav-link"
            [routerLink]="['/roles']"
            routerLinkActive="active"
            >
            <span class="nav-link-title">{{ "roles.roles" | translate }}</span>
          </a>
        }
        @if (showNavLink(locationCanRead)) {
          <a
            class="lns-nav-link"
            [routerLink]="['/locations']"
            routerLinkActive="active"
            >
            <span class="nav-link-title">{{
              "locations.locations" | translate
            }}</span>
          </a>
        }

        @if (showNavLink()) {
          <a
            class="lns-nav-link"
            [matMenuTriggerFor]="messages"
            [class.active]="childrenMessageActive"
            >
            <span class="nav-link-title">{{
              "messages.messages" | translate
            }}</span>
          </a>
        }
        <mat-menu #messages="matMenu">
          <a
            mat-menu-item
            [routerLink]="['/messages/direct']"
            routerLinkActive="active"
            >
            {{ "directMessages.title" | translate }}
          </a>
          <a
            mat-menu-item
            [routerLink]="['/messages/promotional']"
            routerLinkActive="active"
            >
            {{ "announcementAndPromotionalMessages.headTitle" | translate }}
          </a>
          <a
            mat-menu-item
            [routerLink]="['/messages/predefined']"
            routerLinkActive="active"
            >
            {{ "polls.title" | translate }}
          </a>
        </mat-menu>
        @if (showNavLink()) {
          <a
            class="lns-nav-link"
            [routerLink]="['/translations']"
            routerLinkActive="active"
            >
            <span class="nav-link-title">{{
              "translations.translations" | translate
            }}</span>
          </a>
        }
        @if (showNavLink()) {
          <a
            class="lns-nav-link"
            [matMenuTriggerFor]="auditLogs"
            [class.active]="childrenAuditLogsActive"
            >
            <span class="nav-link-title">{{
              "auditLogs.auditLogs" | translate
            }}</span>
          </a>
        }
        <mat-menu #auditLogs="matMenu">
          <a
            mat-menu-item
            [routerLink]="['/audit-logs/mobile']"
            routerLinkActive="active"
            >
            {{ "auditLogs.mobile" | translate }}
          </a>
          <a
            mat-menu-item
            [routerLink]="['/audit-logs/ib']"
            routerLinkActive="active"
            >
            {{ "auditLogs.ib" | translate }}
          </a>
        </mat-menu>
        @if (showNavLink()) {
          <a
            class="lns-nav-link"
            [routerLink]="['/property']"
            routerLinkActive="active"
            >
            <span class="nav-link-title">{{
              "property.property" | translate
            }}</span>
          </a>
        }

        @if (showNavLink()) {
          <a
            class="lns-nav-link"
            [routerLink]="['/changelogs']"
            routerLinkActive="active"
            >
            <span class="nav-link-title">{{
              "changelogs.changelogs" | translate
            }}</span>
          </a>
        }
        @if (showNavLink(tokenCanRead)) {
          <a
            class="lns-nav-link"
            [routerLink]="['/tokens']"
            routerLinkActive="active"
            >
            <span class="nav-link-title">{{ "token.title" | translate }}</span>
          </a>
        }
      </mat-nav-list>
    </div>

    <span class="space"></span>
    <span class="lns-username-span">
      Welcome, <span class="lns-username">{{ username }}</span>
    </span>
    <button mat-button [matMenuTriggerFor]="language">
      <img
        src="../../../../assets/images/language-1.png"
        class="lns-language"
        />
      </button>
      <mat-menu #language="matMenu">
        <button mat-menu-item>
          @if (languages?.data?.length) {
            {{ "language." + languages.data[0].code | lowercase | translate }}
          }
        </button>
      </mat-menu>
      @if (showNavLink()) {
        <button mat-button [matMenuTriggerFor]="account">
          <mat-icon class="lns-logout">account_circle</mat-icon>
        </button>
      }
      <mat-menu #account="matMenu">
        @if (showNavLink()) {
          <button mat-menu-item (click)="logout()">
            {{ "general.logout" | translate }}
          </button>
        }
      </mat-menu>
    </mat-toolbar>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
